import { CHINESE_KEYBOARD_NAME } from '../Custom/Chinese/constants';

export default {
  name: CHINESE_KEYBOARD_NAME.ZHUYIN,
  layout: {
    default: [
      '· ㄅ ㄉ ˇ ˋ ㄓ ˊ ˙ ㄚ ㄞ ㄢ ㄦ …… {bksp}',
      'ㄆ ㄊ ㄍ ㄐ ㄔ ㄗ ㄧ ㄛ ㄟ ㄣ 「 」 、',
      'ㄇ ㄋ ㄎ ㄑ ㄕ ㄘ ㄨ ㄜ ㄠ ㄤ ; {enter}',
      '{shift} ㄈ ㄌ ㄏ ㄒ ㄖ ㄙ ㄩ ㄝ ㄡ ㄥ {shift}',
      '{special} {space} {@}',
    ],
    shift: [
      '~ ! @ # $ % …… & * ( ) _ —— {bksp}',
      'ㄆ ㄊ ㄍ ㄐ ㄔ ㄗ ㄧ ㄛ ㄟ ㄣ 『 』 |',
      'ㄇ ㄋ ㄎ ㄑ ㄕ ㄘ ㄨ ㄜ ㄠ ㄤ : {enter}',
      '{shift} ㄈ ㄌ ㄏ ㄒ ㄖ ㄙ ㄩ , 。 ? {shift}',
      '{special} {space} {@}',
    ],
    special: [
      '. 1 2 3 4 5 6 7 8 9 0 < > {bksp}',
      '[ ] { } # % ^ * + = \\ | _',
      '- / : ; ( ) $ & @ \' ¥ {enter}',
      '… 。 , 、 ? ! ~ “ ” 「 」',
      '{default} {space} {@}',
    ],
  },
};
